const VaccineTemplateRoutes = [
    {
      path: '/vaccine-templates',
      name: 'vaccine-templates',
      component: () => import('@/components/vaccineTemplates/VaccineTemplate.vue'),
    },
  
    {
      path: '/vaccine-templates/:id?',
      name: 'vaccine-template-details',
      component: () =>
          import('@/components/vaccineTemplates/VaccineTemplateDetails'),
  },

    
  ];
  
  export default VaccineTemplateRoutes;
  